gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(TweenMax);

// const panels = gsap.utils.toArray(".steps-working-group");
// panels.forEach((panel, i) => {
//     gsap.fromTo(panel, {}, {
//         scrollTrigger: {
//             trigger: panel,
//             start: 'top 80%',
//             markers: true,
//             scrub: true,
//             onEnter: function () {
//                 $(panel).addClass('_active');
//                 $(panels[i+1]) && $(panels[i+1]).addClass('_open');
//             },
//             onLeaveBack: function() {
//                 $(panel).removeClass('_active');
//                 $(panels[i+1]) && $(panels[i+1]).removeClass('_open');
//             },
//         }
//     });
//     if (i !== panels.length - 1) {
//         gsap.fromTo(panel, {}, {
//             scrollTrigger: {
//                 trigger: panel,
//                 start: 'top 48px',
//                 pin: true,
//                 pinSpacing: false,
//                 // markers: true,
//                 scrub: true,
//             },
//         });
//     }
// });

// const panels = gsap.utils.toArray(".steps-working-group");
// panels.pop();

// panels.forEach((panel, i) => {
//     let tl = gsap.timeline({
//         scrollTrigger: {
//             trigger: ".steps-working-wrap",
//             start: "top " + ($(".steps-working-wrap").innerHeight() + 13),
//             endTrigger: ".steps-working-wrap",
//             end:
//                 "bottom " +
//                 ($(".steps-working-wrap").innerHeight() +
//                     $(panel).innerHeight() +
//                     13),
//             pin: true,
//             markers: true,
//         },
//     });
// });

gsap.fromTo(
    $(".appear-steps-working-wrap"),
    {},
    {
        scrollTrigger: {
            // markers: true,
            toggleClass: "_sticky",
            scrub: true,
            trigger: $(".appear-steps-working-wrap"),
            start: "top 10%",
            end: "bottom -15%",
            id: "sdfdf"
        },
    }
);

$(".steps-working-group").each((index, item) => {
    const heightGroup = $(item).outerHeight() * 2 - (110 * (index + 1)) + "px";
    const top = 0 + ((index+1) * 82) + "px";
    if (index === 0) {
        gsap.fromTo(
            item,
                {
                    "will-change": "opacity, transform",
                    transform: "translateY(0)",
                    // top: "0px"
                    // opacity: 0,
                },
                {
                    scrollTrigger: {
                        trigger: item,
                        start: "top 25%",
                        end: "top 0%",
                        scrub: true,
                        toggleClass: "_active",
                        // markers: true,
                    },
                    // opacity: 1,
                    transform: "translateY(-150px)",
                    // top: top,
                    ease: "none",
                    duration: 3,
                }
        );
    } else {
        gsap.fromTo(
        item,
            {
                "will-change": "opacity, transform",
                transform: "translateY(0)",
                // opacity: 0,
            },
            {
                scrollTrigger: {
                    trigger: item,
                    start: "top 50%",
                    end: "top 10%",
                    scrub: true,
                    // markers: true,
                },
                // opacity: 1,
                transform: `translateY(-${heightGroup})`,
                // top: top,
                ease: "none",
                duration: 3,
            }
    )   ;
    }
});


// WEBPACK FOOTER //
// ./_src/js/modules/PageCategory.js